import { render, staticRenderFns } from "./EditReferenceBasicData.vue?vue&type=template&id=298089c8&"
import script from "./EditReferenceBasicData.vue?vue&type=script&lang=ts&"
export * from "./EditReferenceBasicData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports